// generated/models/agentProposalChangePath.ts
var AgentProposalChangePath = {
  lineItemformularawFormula: "lineItem.formula.rawFormula",
  lineItemarchived: "lineItem.archived",
  lineItemlineItem: "lineItem.lineItem"
};

export {
  AgentProposalChangePath
};
//# sourceMappingURL=chunk-MPYIMQ2L.mjs.map